import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './combineReducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: ['sessionState','dashboardReducer','notificationReducer']
};

const store = createStore(
    persistReducer(persistConfig,
        rootReducer
    ),
    composeEnhancers(applyMiddleware(reduxThunk))
    );
const persistor = persistStore(store);

export { persistor, store };
